"use client"

export function SessionRetry({ message, onRetry, onLogout }: {
  message: string
  onRetry: () => Promise<boolean>
  onLogout: () => void
}) {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center" style={{ background: "#e8e8e8" }}>
      <div className="space-y-4 p-6 text-center">
        <p role="status" className="text-sm text-muted-foreground">{message}</p>
        <button type="button" className="rounded-lg px-4 py-2 text-sm font-medium" style={{ background: "var(--leaf-500)", color: "white" }} onClick={() => void onRetry()}>重试</button>
        <button type="button" className="ml-3 text-sm text-muted-foreground" onClick={onLogout}>重新登录</button>
      </div>
    </div>
  )
}
